import Cookies from 'js-cookie';
import {
  ANALYTICS_IDENTITY,
  ANALYTICS_RESET,
} from '../../helper/scriptHelpers';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';
import { emitter } from 'shared/helpers/mitt';
import {
  clearClientCookies,
  clearIndexedDB,
} from 'dashboard/helper/browserStorageCleanup';
import {
  getGlobalConfig,
  safeRedirectTo,
} from 'dashboard/helper/browserNavigation';
import {
  getAuthCookieOptions,
  getHeaderExpiry,
} from 'dashboard/helper/authCookieExpiry';

export { getHeaderExpiry };

Cookies.defaults = { sameSite: 'Lax' };

export const getLoadingStatus = (state) => state.fetchAPIloadingStatus;
export const setLoadingStatus = (state, status) => {
  state.fetchAPIloadingStatus = status;
};

export const setUser = (user) => {
  emitter.emit(ANALYTICS_IDENTITY, { user });
};

export const setAuthCredentials = (response) => {
  const expiryDate = getHeaderExpiry(response);
  Cookies.set(
    'otello_d_session_info',
    JSON.stringify(response.headers),
    getAuthCookieOptions(response)
  );
  setUser(response.data.data, expiryDate);
};

export const clearBrowserSessionCookies = () => {
  clearClientCookies({ includeCurrentAuth: true });
};

export const clearLocalStorageOnLogout = () => {
  LocalStorage.remove(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES);
};

export const deleteIndexedDBOnLogout = async () => {
  await clearIndexedDB();
};

export const clearCookiesOnLogout = () => {
  emitter.emit(ANALYTICS_RESET);
  clearBrowserSessionCookies();
  clearLocalStorageOnLogout();
  const globalConfig = getGlobalConfig();
  const logoutRedirectLink = globalConfig.LOGOUT_REDIRECT_LINK || '/';
  safeRedirectTo(logoutRedirectLink);
};

export const parseAPIErrorResponse = (error) => {
  if (error?.response?.data?.message) {
    return error?.response?.data?.message;
  }
  if (error?.response?.data?.error) {
    return error?.response?.data?.error;
  }
  if (error?.response?.data?.errors) {
    return error?.response?.data?.errors[0];
  }
  return error;
};

export const throwErrorMessage = (error) => {
  const errorMessage = parseAPIErrorResponse(error);
  throw new Error(errorMessage);
};
